module.exports = __webpack_public_path__ + "static/digital562b237c92667456bfb32ff0484c0ad14.png";